import { EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import * as moment from 'moment';
import { OrderHistory } from '../../models/orderhistory';
var OrderhistorylinesPageComponent = /** @class */ (function () {
    function OrderhistorylinesPageComponent(location) {
        this.location = location;
        this.onExpand = new EventEmitter();
        this.onReOrder = new EventEmitter();
    }
    Object.defineProperty(OrderhistorylinesPageComponent.prototype, "getCartProducts", {
        get: function () {
            return JSON.stringify(this.cartProducts);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderhistorylinesPageComponent.prototype, "requestedDeliveryDate", {
        get: function () {
            if (this.orderHistoryItem && this.orderHistoryItem.dlvDate && moment(this.orderHistoryItem.dlvDate).isValid()) {
                return moment(this.orderHistoryItem.dlvDate).format('DD-MM-YYYY');
            }
        },
        enumerable: true,
        configurable: true
    });
    OrderhistorylinesPageComponent.prototype.goBack = function () {
        this.location.back();
    };
    OrderhistorylinesPageComponent.prototype.expand = function () {
        this.onExpand.emit();
    };
    OrderhistorylinesPageComponent.prototype.reOrder = function (productId) {
        this.onReOrder.emit(productId);
    };
    OrderhistorylinesPageComponent.prototype.isInCart = function (line) {
        if (line.currentProduct && line.currentProduct.length > 0) {
            var productId = line.currentProduct[0]._id;
            var product = this.cartProducts[productId];
            return !!product;
        }
        return false;
    };
    OrderhistorylinesPageComponent.prototype.isReOrderable = function (line) {
        if (line && line.productCode) {
            return this.reOrderableProductCodes.indexOf(line.productCode) >= 0;
        }
        return false;
    };
    return OrderhistorylinesPageComponent;
}());
export { OrderhistorylinesPageComponent };
